import { TextFieldProps } from '@mui/material';
import { ReactElement } from 'react';
import { SystemStyleObject } from '@mui/system';
import { ScopeId } from 'common/types/common';
import { useCurrrentRoute } from 'common/hooks/use-current-route';
import { useMeQuery } from 'common/hooks/api/queries/use-users-query';
import { SelectField } from '../../select-field';
import { useScopeContext } from '../../scopes/scope-ctx';

interface Props {
  sx?: SystemStyleObject;
  variant?: TextFieldProps['variant'];
  fullWidth?: boolean;
  forceRedirect?: boolean;
  redirect?: string;
}

export function TenantSelect({
  sx,
  variant = 'filled',
  fullWidth,
  forceRedirect = true,
  redirect,
}: Props): ReactElement {
  const { isProtectedRoute } = useCurrrentRoute();

  const { data: meData } = useMeQuery({ enabled: Boolean(isProtectedRoute) });

  const { scope, setScope, isFetchedScope } = useScopeContext();

  const scopes = meData?.scopes ?? [];

  const options = scopes?.map(scope => ({
    label: scope.name,
    value: scope.id,
  }));

  const handleChange = (value: ScopeId) => {
    const scopeItem = scopes?.find(item => value === item?.id);
    setScope(scopeItem);
    if (forceRedirect) window.location.href = redirect ?? '/';
    else window.location.reload();
  };

  return isFetchedScope ? (
    <SelectField
      label="Channel"
      options={options ?? []}
      variant={variant}
      value={scope?.id}
      onChange={handleChange}
      selectSx={sx}
      fullWidth={fullWidth}
      SelectProps={{
        disableUnderline: true,
        MenuProps: {
          PaperProps: {
            sx: {
              mt: 1,
              maxHeight: 300,
              overflowY: 'auto',
            },
          },
        },
      }}
    />
  ) : null;
}
